import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useEffect, useState } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import dateService from '@gem/services/date-service';

import styles from './CallTime.styles.m.css';

interface ICallTimeProps {
  call: Call;
  className?: string;
}

export const CallTime: FC<ICallTimeProps> = observer(({ call, className }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    function calculateSeconds(startTs: number): number {
      return Math.floor((Date.now() - startTs) / 1000);
    }

    if (call.startTs) {
      setSeconds(calculateSeconds(call.startTs));
    }

    const timer = setInterval(() => {
      if (call.startTs) {
        setSeconds(calculateSeconds(call.startTs));
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [call.startTs]);

  if (!call) {
    return null;
  }

  return (
    <div className={classNames(styles.time, className)}>{dateService.secondsToString(seconds)}</div>
  );
});
